// eslint-disable-next-line no-restricted-imports
import API from 'api';
// eslint-disable-next-line no-restricted-imports
import { actionCreator } from 'util/actions';
import { MEMBER_FIELDS_MINIMAL } from './fields';

// Ation types
export const LOAD_MEMBER_PROFILE_REQUEST =
  'loaders/LOAD_MEMBER_PROFILE_REQUEST';
export const LOAD_MEMBER_PROFILE_SUCCESS =
  'loaders/LOAD_MEMBER_PROFILE_SUCCESS';
export const LOAD_MEMBER_PROFILE_ERROR = 'loaders/LOAD_MEMBER_PROFILE_ERROR';

// Ation creators
const loadMemberProfileRequest = actionCreator(LOAD_MEMBER_PROFILE_REQUEST);
const loadMemberProfileSuccess = actionCreator(LOAD_MEMBER_PROFILE_SUCCESS);
const loadMemberProfileError = actionCreator(LOAD_MEMBER_PROFILE_ERROR);

export const loadMemberProfile = (idMemberOrUsername) => {
  return async (dispatch) => {
    try {
      dispatch(loadMemberProfileRequest(idMemberOrUsername));

      const member = await API.client.rest.get(
        `members/${idMemberOrUsername}`,
        {
          query: {
            fields: MEMBER_FIELDS_MINIMAL,
            tokens: 'all',
            sessions: 'all',
            credentials: 'all',
            logins: true,
          },
        },
      );

      API.socket.subscribe('member', member.id, [
        'messages',
        'updates',
        'self',
      ]);

      dispatch(loadMemberProfileSuccess(member));
    } catch (err) {
      dispatch(loadMemberProfileError(err));
    }
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/loaders/load-member-profile.js